module.exports = __webpack_public_path__ + "images/stickers/pete-talk@2x.217a5d2b04a6dea23726.png";